export const Consts = {
    contactEmail: "contact@stack3.net"
}